<template>
<div style="height:100vh">
    <Sidebar/>
    
    <div class="d-flex justify-content-center flex-wrap h-75">
        
        <panel text="Visite virtuelle" img='3d.png' url="/appartement-1"/>
            <panel text='Que faire à proximité ?' img='ville.png' url="clos/gaillon"/>
       
            
    </div>
    
</div>
    
</template>

<script>
import Sidebar from '../components/Sidebar'
import panel from '../components/Panel-appartement'
export default {
    name : 'Logis',
    components : {
        Sidebar,
        panel
    },
    beforeCreate: function() {
        document.body.className = 'logis';
    },
    
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Indie+Flower&display=swap');
body {
    background-color: burlywood!important;
    background-image: none!important;
}
div {
    font-family: 'Indie Flower', cursive;
    font-size: 20px;
}
</style>